import { useQuery } from '@tanstack/react-query';

import Api from '@/services/api';
import { QUERY_KEYS } from '@/utils/query-keys';
import type { AxiosErrorResponse, BaseReportsPaginated, BaseReportsPaginatedResponse, PaginatedData } from '@/types';

export type ListAllNioshDTO = BaseReportsPaginated;

export type ListAllNioshResponse = PaginatedData<BaseReportsPaginatedResponse>;

async function listNioshPaginated(params: ListAllNioshDTO): Promise<ListAllNioshResponse> {
	const url = '/ergonomic-tool/niosh/reports/list-all';
	const { data } = await Api.get<ListAllNioshResponse>(url, {
		params
	});
	return data;
}

export const useListNioshPaginated = ({
	limit,
	offset,
	sector_id,
	cellule_id,
	company_id,
	report_name,
	activity_id,
	evaluator_id,
	original_name,
	created_at_end,
	workstation_id,
	organization_id,
	created_at_start,
	isSelectedReport
}: ListAllNioshDTO) => {
	const enabled = !!limit && !!isSelectedReport && offset >= 0;
	const nioshReport = useQuery<ListAllNioshResponse, AxiosErrorResponse>(
		[
			QUERY_KEYS.GET_NIOSH_REPORTS_PAGINATED,
			[
				limit,
				offset,
				sector_id,
				cellule_id,
				company_id,
				report_name,
				activity_id,
				evaluator_id,
				original_name,
				created_at_end,
				workstation_id,
				organization_id,
				created_at_start
			]
		],
		() =>
			listNioshPaginated({
				limit,
				offset,
				sector_id,
				cellule_id,
				company_id,
				report_name,
				activity_id,
				evaluator_id,
				original_name,
				created_at_end,
				workstation_id,
				organization_id,
				created_at_start
			}),
		{
			enabled,
			retry: 0
		}
	);
	return nioshReport;
};
